import { quartiles } from './descriptive';

export interface TukeyResult {
  lowerFence: number;
  upperFence: number;
  outlierIndices: number[];
}

export function tukeyOutliers(xs: readonly number[]): TukeyResult {
  const q = quartiles(xs);
  const iqrValue = q.q3 - q.q1;
  const lowerFence = q.q1 - 1.5 * iqrValue;
  const upperFence = q.q3 + 1.5 * iqrValue;
  const outlierIndices: number[] = [];
  for (let i = 0; i < xs.length; i++) {
    const x = xs[i]!;
    if (x < lowerFence || x > upperFence) outlierIndices.push(i);
  }
  return { lowerFence, upperFence, outlierIndices };
}
